import styled from 'styled-components'

export const HomeBgContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`

export const HomeNonHeaderContainer = styled.div`
  display: flex;
  flex-grow: 1;
  overflow: auto;
  width: 100%;
`

export const SearchAndVideosContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${props => (props.darkMode ? '#181818' : '#f9f9f9')};
  padding: 20px;
`

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0.7px solid #7e858e;
  align-self: flex-start;
  border-radius: 4px;
  width: 30%;
  background-color: transparent;
`

export const SearchInput = styled.input`
  border-width: 0px;
  padding: 12px;
  border-radius: 4px;
  color: #64748b;
  flex-grow: 1;
  outline: none;
  background-color: transparent;
`

export const SearchBtn = styled.button`
  width: 80px;
  font-size: 16px;
  cursor: pointer;
  outline: none;
  align-self: stretch;
  border: 0 solid #7e858e;
  color: ${props => (props.darkMode ? '#7e858e' : '#7e858e')};
  background-color: ${props => (props.darkMode ? '#212121' : '#f4f4f4')};
  border-width: 0 0 0 1px;
  border-radius: 0 4px 4px 0;
`

export const BannerAndVideosContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 83%;
  overflow: auto;
`

export const NonVideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
  flex-grow: 1;
`

export const NoVideoImg = styled.img`
  width: 40%;
  min-width: 220px;
`

export const FailureHeading = styled.h1`
  color: ${props => (props.darkMode ? '#ffffff' : '#181818')};
`

export const FailureContent = styled.p`
  color: ${props => (props.darkMode ? '#94a3b8' : '#181818')};
`

export const RetryBtn = styled.button`
  border-width: 0;
  background-color: #4f46e5;
  color: white;
  padding: 14px;
  border-radius: 8px;
  width: 100px;
  cursor: pointer;
  outline: none;
`

export const LoaderContainer = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`
